import {Injectable, NgZone} from '@angular/core';
//import {BackgroundGeolocation} from "@ionic-native/background-geolocation";
import {Geolocation} from '@ionic-native/geolocation';
import {Platform} from "ionic-angular";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {DataService} from "./data-service";
import {StorageService} from "./storage-service";
import {Util} from "../app/util";
import {CONFIG} from "../app/config";


@Injectable()
export class GeolocationService {

    public subscription: Subscription;
    public watch: Subscription;
    public latitude: number = 0;
    public longitude: number = 0;

    constructor(public geolocation: Geolocation,
                public platform: Platform, public util: Util, private ngZone: NgZone,
                public storageService: StorageService, public dataService: DataService,
                //, public backgroundGeolocation: BackgroundGeolocation
                ) {

    }

    startTracking(): Observable<any> {

        return this.subscription = Observable.create((observer) => {

            if (!this.platform.is('cordova')) {
                observer.next({});
                observer.complete();
                return;
            }

            /** DURANTE O USO DO APP **/
            /** ******************** **/
            //Solicita utilização Geolication
            this.geolocation.getCurrentPosition().then((resp) => {
                //console.log('GEO-REGISTER:', resp.coords.latitude, resp.coords.longitude);

                //Foreground - browser e nativo
                let options = {maximumAge: CONFIG.geolocation.frequency, timeout: CONFIG.geolocation.timeout, enableHighAccuracy: true};

                this.watch = this.geolocation.watchPosition(options)
                    .subscribe(
                        (position: any) => {

                            if (position && position.coords && position.coords.latitude) {

                                this.storageService.set('LOADED-LOCATION', true, true).subscribe();
                                this.dataService.set('LOADED-LOCATION', true);

                                // garante que haverá atualização de onde estiver sendo exibida nos controllers/views
                                this.ngZone.run(() => {
                                    this.latitude = position.coords.latitude;
                                    this.longitude = position.coords.longitude;
                                });

                                //console.log('GEO-UPDATE:', this.latitude, this.longitude);

                                observer.next({
                                    latitude: position.coords.latitude,
                                    longitude: position.coords.longitude
                                });

                            }
                            else {
                                observer.error({
                                    Title: 'Ops!',
                                    Result: 'Não foi possível obter sua localização.'
                                });
                            }

                        },
                        erro => {
                            observer.error({
                                Title: 'Ops!',
                                Result: erro.message
                            });
                        });


            }).catch((erro) => {

                erro.Result = 'Autorize nos ajustes o acesso a localização.';
                erro.Result = 'Para voltar a calcular a distância, ative manualmente e reinicie seu dispositivo.';
                observer.error(erro);
                //observer.complete();

            });

            /** BACKGROUND APENAS NATIVO **/
            /** ************************ **/
            /*
                                            let config = {
                                                desiredAccuracy: 0,
                                                stationaryRadius: CONFIG.geolocation.radius,
                                                distanceFilter: CONFIG.geolocation.distance,
                                                debug: false, // lembrar de setar falso no app compilado
                                                stopOnTerminate: false,
                                                interval: CONFIG.geolocation.frequency, // usar config, 30s seria um bom tempo
                                                //url: '', // url para enviar em background (app terminado)
                                                //syncUrl: '' // url para enviar os erros em background (app terminado) [não precisa usar, se off, usa a url] {se setar só essa, será enviado grupos de req. após atingir syncThreshold}
                                            };

                                            // verificar se está fazendo requisição apenas quando o app está em bg / terminado

                                            this.backgroundGeolocation.configure(config)
                                                .subscribe((location) => {

                                                    // testar enviar http por aqui com o app fechado, senão usar url e syncUrl

                                                    //console.log('BackgroundGeolocation:  ' + location.latitude + ',' + location.longitude);

                                                    if (location && location.latitude) {

                                                        // garante que haverá atualização de onde estiver sendo exibida nos controllers/views
                                                        this.ngZone.run(() => {
                                                            this.latitude = location.latitude;
                                                            this.longitude = location.longitude;
                                                        });

                                                        observer.next({
                                                            latitude: location.latitude,
                                                            longitude: location.longitude
                                                        });
                                                    }
                                                    else {
                                                        observer.error({
                                                            Title: 'Ops!',
                                                            Result: 'Não foi possível obter sua localização.'
                                                        });
                                                    }

                                                }, (erro) => {

                                                    observer.error({
                                                        Title: 'Ops!',
                                                        Result: erro.message
                                                    });

                                                });
            */

            //this.backgroundGeolocation.start();

        });

    }

    public getLocation() {

        return {
            latitude: this.latitude,
            longitude: this.longitude
        };

    }

    stopTracking() {

        //this.backgroundGeolocation.finish(); // para de monitorar em background (app fechado)
        this.watch.unsubscribe(); // para de monitorar (não usando watch)
        this.subscription.unsubscribe(); // finaliza o subscribe

    }

}



// WEBPACK FOOTER //
// ./src/providers/geolocation-service.ts